// @ts-nocheck
import { GetStoreListCustomersApiParameter } from "@store/Services/StoreListService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<Partial<GetStoreListCustomersApiParameter>>;

export const DispatchUpdateShipTosParameter: HandlerType = props => {
    props.dispatch({
        type: "Pages/StoreListDetails/UpdateCustomersParameter",
        result: props.parameter,
    });
};

export const chain = [DispatchUpdateShipTosParameter];

const updateCustomersPagination = createHandlerChainRunner(chain, "UpdateCustomersPagination");
export default updateCustomersPagination;
